<template>
	<div class="business-home-wrapper">
		<ResidentialHome v-if="showResidentialHome" />
		<BrandWall v-else-if="showBrandWall" />
		<Table v-else-if="showTable" />
	</div>
</template>

<style scoped>
.business-home-wrapper {
	height: 100%;
}
</style>

<script>
import { BusinessType } from "@reef-os/utils/enums/businessType"
import loaderMixin from "@/mixins/loader-mixin"
import Table from "@/components/Table.vue"
import ResidentialHome from "@/components/ResidentialHome.vue"
import BrandWall from "@/components/brand/BrandWall.vue"

export default {
	name: "BusinessHome",
	mixins: [loaderMixin],
	components: {
		Table,
		ResidentialHome,
		BrandWall
	},
	computed: {
		showTable() {
			return (
				!this.loading &&
				!this.showResidentialHome &&
				!this.showBrandWall
			)
		},
		showResidentialHome() {
			return (
				!this.loading &&
				this.$store.state.business.type == BusinessType.RESIDENTIAL
			)
		},
		showBrandWall() {
			return !this.loading && this.$store.getters.isAirport
		},
		loading() {
			return this.$store.state.loading
		}
	},
	created: function () {
		this.$store.dispatch("initHome", this.$route.params.slug)
	},
	mounted: function () {
		this.toggleLoader(true)
		const unsubscribe = this.$store.watch(
			(state) => state.loading,
			(loading) => {
				if (!loading) {
					unsubscribe()
					this.finishedLoading()
				}
			}
		)
	},
	methods: {
		finishedLoading: function () {
			this.toggleLoader(false)
			const outOfStock = !this.$store.state.business.stock_status
			const inactive = !this.$store.state.business.is_active
			const shouldSkipTable =
				this.$store.state.business.type != BusinessType.HOTEL &&
				this.$store.state.business.type != BusinessType.RESIDENTIAL &&
				this.$store.state.business.type != BusinessType.COWORKING
			if (
				this.$store.state.business &&
				(outOfStock || inactive) &&
				shouldSkipTable
			) {
				this.$router.push({
					name: "menu",
					params: { slug: this.$route.params.slug }
				})
			}
		}
	}
}
</script>